
import axios from "axios";

// eslint-disable-next-line no-extend-native
Date.prototype.addHours = function (h) {
  this.setTime(this.getTime() + (h * 60 * 60 * 1000));
  return this;
}

export default class Auth {
  async getUserLoginInfo(userId,accessToken) {
    console.log("Getting user login info with admin token", this.authData);

    const done = await axios.get(`https://api-services-connect.tunedglobal.com/api/v3/users/${userId}/profile`, {
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'StoreId': `${process.env.REACT_APP_STOREID}`
      }
    })
      .then((userResponse) => {
        console.log("User info response", userResponse);
        // Check if userResponse.data is an array or object
        const userDataArray = Array.isArray(userResponse.data) ? userResponse.data : [userResponse.data];
        // Logins: [0: {Type: 'Msisdn', Value: '97695855767', GroupId: 'MNCO '}]
        if (userDataArray && userDataArray.length > 0) {
          const userEntry = userDataArray[0];
          const logins = Array.isArray(userEntry.Logins) ? userEntry.Logins : [];

          const emailItem = logins.find(item => item.Type === "Email");
          if (emailItem && emailItem.Value) {
            this.authData = {
              ...this.authData,
              username: emailItem.Value
            };
          }

          const phoneItem = logins.find(item => item.Type === "Msisdn");
          if (phoneItem && phoneItem.Value) {
            this.authData = {
              ...this.authData,
              phone: {
                number: phoneItem.Value
              }
            };
          }
          console.log("Updated authData with user info", this.authData);
          return true;
        }
      })
      .catch((error) => {
        console.error("User info error", error);
        return null;
      });

    return done;
  }

  async loadSilentAuth() {
    try {
      //cms admin token hereg bolj bagadguil ym daraa
      const response = await axios.post(
        'https://api-authentication-connect.tunedglobal.com/oauth2/token',
        new URLSearchParams({
          grant_type: 'password',
          admin: 'Y',
          country: 'MN',
          username: process.env.REACT_APP_SILENT_AUTH_USERNAME,
          password: process.env.REACT_APP_SILENT_AUTH_PASSWORD,
        }).toString(),
        {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }
      )
        .then(async (response) => {
          console.log("Silent auth response", response);
          const { access_token } = await response.data;
          this.authData.admin_token = access_token;
          return access_token;
        })
        .catch((error) => {
          console.error("Silent auth error", error);
        });
      return response;
    } catch (error) {
      console.error("Silent auth exception", error);
    }
  }

  async getAuthData() {
    await this.getUserLoginInfo(this.authData.sub,this.authData.access_token);
    return this.authData;
  }

  storeAuth() {
    const date = new Date();
    date.addHours(1);
    document.cookie = `authData=${JSON.stringify(this.authData)}; expires=${date}; path=/`;
  }

  loadAuth() {
    var decodedCookie = decodeURIComponent(document.cookie);
    var result = decodedCookie.match(new RegExp('authData=([^;]+)'));

    if (result === null) {
      this.authData = null;
      return;
    }
    this.authData = JSON.parse(result[1]);
  }

  async loadSubscriptions() {
    try {
      const gt = axios.get(`${process.env.REACT_APP_SERVICES_API_BASE}/users/${this.authData.sub}/subscriptions/`,
        {
          headers: {
            'StoreId': `${process.env.REACT_APP_STOREID}`,
            'Authorization': `Bearer ${this.authData.access_token}`
          },
          params: {
            'IsFutureActive': false
          }
        }
      )
      return gt;
    } catch (err) {
      return null;
    }
  }

  isAuthenticated() {
    return this.authData !== null && this.authData !== undefined
  }

  logout() {
    // Clear all cookies
    document.cookie.split(";").forEach(c => {
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    
    // Clear all storage
    localStorage.clear();
    sessionStorage.clear();
    
    this.authData = null;
    window.location.reload();
  }

}